import { dataShareAlt } from 'dls-icons-data'
import { createIcon } from '../common'

const IconShareAlt = /*#__PURE__*/createIcon(dataShareAlt)
export default IconShareAlt
